module.exports = __webpack_public_path__ + "static/media/ux-min.b991d578.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/ux-min.svg
// module id = 698
// module chunks = 0